import { Card, Text, Badge, Group, useMantineTheme } from '@mantine/core';
import Imgix from "react-imgix";
import useBoardHook from "../utils/useBoardHook";
import {useMemo} from "react";

var GeoPattern = require('geopattern');
export default function BoardCard({image, subdomain, title, published, admin, onClick, onlySection, hideStatus}) {
    const theme = useMantineTheme();
    const source= image ? `https://d2uqrxzbny1jco.cloudfront.net/fit-in/500x500/${image}` : `${GeoPattern.generate(subdomain).toDataUri()}`;


    const CardSection = useMemo(() => {
        return (
            <Card.Section className="fitBackground relative">
            {
                image ?  <Imgix imgixParams={{ fit: "crop", ar: "1:1" }} src={source} id="imgix"/> : <img src={source} alt="cover_card" id="avatargen"/>
            }

            {/*<Text weight={500}>{title || subdomain}</Text>*/}
                {
                    !hideStatus && <div style={{position:"absolute", left: 10, top:10}}>
                        {!published && <Badge color="yellow" size={"xs"} radius="sm" variant="filled">
                            In lucru
                        </Badge> }
                    </div>
                }

            <div style={{position:'absolute', bottom:10, left: 10}}>  <Badge radius="sm" color="dark"  size="xs" variant="filled">{title}</Badge></div>
        </Card.Section>
        )
    }, [image])


    return useMemo(() => {
        if (onlySection) {
            return CardSection
        }
        return (
            <Card shadow="sm" p="lg" radius={null} className="relative" onClick={onClick}>
                {CardSection}
            </Card>
        );
    }, [image, onlySection])

}